import { Text } from '@mantine/core'
import '../../styles/variables.css'
import TextClasses from './styles.module.css'

export default Text.extend({
    classNames: TextClasses,
})
